/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddUnderSecretaryDecisionCommand } from '../../models/add-under-secretary-decision-command';
import { AddUnderSecretaryDecisionCommandResult } from '../../models/add-under-secretary-decision-command-result';

export interface ApiTaskAddUnderSecretaryDecisionPut$Params {
      body?: AddUnderSecretaryDecisionCommand
}

export function apiTaskAddUnderSecretaryDecisionPut(http: HttpClient, rootUrl: string, params?: ApiTaskAddUnderSecretaryDecisionPut$Params, context?: HttpContext): Observable<StrictHttpResponse<AddUnderSecretaryDecisionCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiTaskAddUnderSecretaryDecisionPut.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AddUnderSecretaryDecisionCommandResult>;
    })
  );
}

apiTaskAddUnderSecretaryDecisionPut.PATH = '/api/Task/AddUnderSecretaryDecision';
